module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_concept_02-3c1f481a4a5e4f7d513063043482f3a1.jpg";